<div class="card-grid width-100" *ngIf="display === 'grid'" #grid>
  <ng-container *ngFor="let entry of entries">
    <uni-project-card
      [class.featured]="featured"
      [project]="entry.project"
      [version]="entry.project_version"
      [featured]="featured"
      [host]="host"
      [showUsers]="showUsers"
      [border]="border"
      [footerType]="footerType"
      [contentType]="contentType"
      [truncate]="truncate">
    </uni-project-card>
  </ng-container>
</div>

<div class="card-grid width-100" id="grid-breakpoint" *ngIf="display === 'breakpoint'" #grid>
  <ng-container *ngFor="let entry of visible_entries">
    <uni-project-card
      [class.featured]="featured"
      [project]="entry.project"
      [version]="entry.project_version"
      [featured]="featured"
      [host]="host"
      [showUsers]="showUsers"
      [border]="border"
      [footerType]="footerType"
      [contentType]="contentType"
      [truncate]="truncate">
    </uni-project-card>
  </ng-container>
</div>
